<template>
  <div>
    <input
        type='email'
        class='text'
        v-model='userEmail'
        placeholder="E-mail"
    >

    <div class='button-wrapper'>
      <button
          class='wide btn'
          :disabled='!userEmail'
          @click='sendResetEmail'
      >
        Stuur e-mail
      </button>
    </div>

    <div
        class='error-message'
        v-if='errorMessage'
    >
      {{ errorMessage }}
    </div>

    <div
        class='success'
        v-if='successMessage'
    >
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ResetPasswordForm",
  data() {
    return {
      userEmail: "",
      errorMessage: "",
      emailErrorMessages: "",
      successMessage: "",
      loading: true,
    };
  },
  methods: {
    ...mapActions("user", [
      "forgotPassword",
    ]),
    sendResetEmail() {
      this.errorMessage = "";
      this.emailErrorMessages = "";
      this.successMessage = "";
      this.loading = true;

      if (this.userEmail.length > 0) {
        let requestData = {
          email: this.userEmail,
        };

        this.forgotPassword(requestData)
            .then(response => {
              if (response.status === 422) {
                this.errorMessage = "Ongeldige invoer, controleer je e-mailadres.";
              } else if (response.status === 404) {
                this.errorMessage = "We hebben geen account gevonden met dat e-mailadres.";
              } else if (response.status === 500) {
                this.errorMessage = "Kon geen verbinding maken met de server.";
              } else {
                this.successMessage = "We hebben je een wachtwoord reset mail gestuurd";
                this.userEmail = '';
              }
            })
            .catch(err => {
              if (err.response) {
                const status = err.response.status;

                if (status === 422) {
                  this.errorMessage = "Ongeldige invoer, controleer je e-mailadres.";
                } else if (status === 404) {
                  this.errorMessage = "We hebben geen account gevonden met dat e-mailadres.";
                } else if (response.status === 500) {
                  this.errorMessage = "Kon geen verbinding maken met de server.";
                } else {
                  this.errorMessage = "Er ging iets fout. Probeer het later opnieuw.";
                }
              } else {
                this.errorMessage = "Kon geen verbinding maken met de server.";
              }
            })
            .finally(() => {
              this.loading = false;
            });

      } else {
        this.errorMessage = "Vul alle velden in";
        this.loading = false;
      }
    }

  },
};
</script>
